export default {
  brands: null,
  brandListStatus: null
}